


























































































































































































































































































































































import _pickBy from "lodash/pickBy";
import _filter from "lodash/filter";
import _isObject from "lodash/isObject";
import $ from "jquery";
import { Component, Vue, Watch } from "vue-property-decorator";
import QPaginate from "@/common/qPaginate.vue";
import PaginateModel from "@/model/paginate";
import store from "@/store";
import orderApi from "@/api/orderApi";
import moment from "moment";
import QProductPopup from "@/common/qProductPopup.vue";
import {
  DATE_PICKER_FORMAT,
  DATE_TIME_FORMAT,
  DATE_TIME_TEXT_FORMAT, DATETIME_FORMAT_PDF_FILE_NAME,
  ITEM_STATUS_DELETED,
} from "@/common/constant";
import QCalendar from "@/common/qCalendar.vue";
import CartItem from "@/model/cart";
import User from "@/model/user";
import { namespace } from "vuex-class";
import qNotify from "@/common/qNotify";
import anime from "animejs";

const authStore = namespace("Auth");
const cartStore = namespace("Cart");
const orderStore = namespace("OrderInformation");

@Component({
  name: "History",
  components: {
    QPaginate,
    QCalendar,
    QProductPopup,
  },
})
export default class History extends Vue {
  @authStore.Getter
  getUserLogging!: User;

  @cartStore.Getter
  cartItems!: any[];

  @cartStore.Action
  public addCart!: (product) => void;

  @orderStore.Action
  public addOrderInformation!: (any) => void;

  @orderStore.Action
  public isUpdateFlash!: (boolean) => void;

  @orderStore.Getter
  orderItems!: any[];

  public orderHistories = [];
  public isRelayFee = "1";
  public postAgeItemCode = "000082";
  public pipPostAgeItemCode = "000083";
  public unDisplayItemCodes = ['000082', '000083', '000085'];

  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });

  public search = {
    date_type: "2",
    date_from: moment().subtract(30, "days").format(DATE_TIME_FORMAT),
    date_to: moment().format(DATE_TIME_FORMAT),
    account_code: null,
    dlv_dst_name: "",
    item_name_2: "",
    item_code: "",
    denno_shipment: "",
    denno_orre: "",
    status: ["受付済", "準備中", "出荷済", "取消"],
    page: null,
    is_front_history: true,
  };

  public date_types = [
    { type: 2, type_name: "ご注文日" },
    { type: 1, type_name: "納入日（売上日）" },
    { type: 3, type_name: "確定出荷日" },
  ];

  public customerSupervisorName = [];

  public datePickerConfig = {
    dateFormat: DATE_PICKER_FORMAT,
  };

  public orderSelected = [];
  public isStatusAll = false;

  async mounted() {
    console.log("HISTORY");
    this.getCustomer({ notLoading: true });
    this.initSearch(null);
    this.doSearch(this.search);
  }

  public async getCustomer(query) {
    this.customerSupervisorName = await orderApi.getCustomerSupervisorName(query);
  }

  public onSearch(): void {
    // this.changeState();
    this.search.page = 1;
    this.doSearch(this.search);
    this.orderSelected = [];
    this.isStatusAll = false;
  }

  public resetSearch() {
    this.initSearch({});
    // this.changeState(true);
    this.doSearch(this.search);
    this.orderSelected = [];
    this.isStatusAll = false;
  }

  async clickToStatus() {
    this.orderSelected = [];
    this.isStatusAll = !this.isStatusAll;
    if (this.isStatusAll) {
      this.orderHistories.map((order) => {
        this.orderSelected.push(order.denno_shipment);
      });
    } else {
      this.orderSelected = [];
    }
  }

  public async doSearch(query: any) {
    this.changeState()
    store.dispatch("Router/setSearchParameters", {
      orderHistory: { ...query },
    });
    const result = await orderApi.getHistoryParentRecord(query);
    this.pagination = result.paginate;
    this.orderHistories = result.orderHistories;

    this.orderHistories.map(async (item, index) => {
      let childOrder = [];
      item.child_rows.map(async (order) => {
        childOrder.push(new CartItem(order));
      });
      this.orderHistories[index].child_rows = childOrder;
    });
    // this.customerSupervisorName = await orderApi.getCustomerSupervisorName();
  }

  public initSearch(parameters): void {
    const query = parameters || this.$router.currentRoute.query;
    if (query.status && !_isObject(query.status)) {
      query.status = [query.status];
    }

    this.search = {
      date_type: 2,
      date_from: moment().startOf("month").format(DATE_TIME_FORMAT),
      date_to: moment().endOf("month").format(DATE_TIME_FORMAT),
      account_code: this.getUserLogging?.account_code || null,
      dlv_dst_name: null,
      item_name_2: null,
      item_code: null,
      denno_shipment: null,
      denno_orre: null,
      status: ["受付済", "準備中", "出荷済", "取消"],
      page: 1,
      is_front_history: true,
      ...query,
    };
  }

  public changeState(clear = false): void {
    let { name, params, query }:any = this.$router.currentRoute;

    query = { ...query, ...this.search };

    if (clear) {
      query = {};
    }

    query = _pickBy(query, (item) => item);

    this.$router
      .replace({ hash: "#history", name: name, params: params, query })
      .catch((error) => {
        console.error(error);
      });
  }

  parentClick(event) {
    const currentElement = event.currentTarget;
    $(currentElement).parent().next(".js__drill-box").slideToggle();
    $(currentElement).toggleClass("open");
  }

  getOrderDate(row) {
    if (row.orre_date && row.account_supervisor_name) {
      return (
        moment(row.orre_date).format(DATE_TIME_TEXT_FORMAT) +
        "（" +
        row.account_supervisor_name +
        "）"
      );
    } else {
      return "";
    }
  }

  lastUpdateDate(row) {
    if (row.last_update_date && row.last_updated) {
      return (
        moment(row.last_update_date).format(DATE_TIME_TEXT_FORMAT) +
        "（" +
        row.last_updated.account_supervisor_name +
        "）"
      );
    } else if (row.last_update_date && row.account_supervisor_name) {
      return (
        moment(row.last_update_date).format(DATE_TIME_TEXT_FORMAT) +
        "（" +
        row.account_supervisor_name +
        "）"
      );
    } else {
      return "";
    }
  }

  getItemAvaiable(parentRow) {
    return parentRow.child_rows.filter(child => child.item.status != ITEM_STATUS_DELETED);
  }

  getTotalQuantity(parentRow) {
    let result = 0;
    if (parentRow.child_rows) {
      this.getItemAvaiable(parentRow).filter(child => {
        if (![this.postAgeItemCode, this.pipPostAgeItemCode].includes(child.item.item_code)) {
          if (child.item.set_item_code) {
            result += child.item.set_quantity;
          } else {
            result += child.item.orre_quantity;
          }
        }
      });
    }

    return result;
  }

  getTotalPrice(parentRow) {
    let result = 0;
    if (parentRow.child_rows) {
      this.getItemAvaiable(parentRow).filter(child => {
        if (child.item.set_item_code) {
          result += child.item.set_quantity * child.item.set_price;
        } else {
          result += Number.parseInt(Intl.NumberFormat().format(child.item.orre_aomount));
        }
      });
    }

    return result;
  }

  async downloadPdf() {
    var selectedShipmentsByCustomer = this.groupShipmentByCustomer();

    for (const customerCode in selectedShipmentsByCustomer) {
      const selectedShipmentByCompany = selectedShipmentsByCustomer[customerCode];
      orderApi.downloadPdf({shipments: selectedShipmentByCompany.denno_shipments}).then(
        (response) => {
          if (response.status == "200") {
            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
            const fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute(
              "download",
              this.$t(`download_files.order_history`, {
                filename: selectedShipmentByCompany.customer_name + '_' + moment().format(DATETIME_FORMAT_PDF_FILE_NAME),
              }).toString()
            );

            // eslint-disable-next-line unicorn/prefer-dom-node-append
            document.body.appendChild(fileLink);
            fileLink.click();

            // eslint-disable-next-line unicorn/prefer-dom-node-remove
            document.body.removeChild(fileLink);

            qNotify.success({
              text: this.$t("order_history_page.messsage.print_pdf_success"),
            });
          }
        }
      );
    }
  }

  public groupShipmentByCustomer() {
    let selectedRow = this.orderHistories.filter((item) => {
      return item.status == "出荷済" && this.orderSelected.includes(item.denno_shipment)
    });
    let selectedShipmentByCustomer = [];
    selectedRow.map((row) => {
      const customerCode = row.customer_code;
      selectedShipmentByCustomer[customerCode] = selectedShipmentByCustomer[customerCode] ?? {
        customer_name : row.customer_name,
        denno_shipments : []
      };
      selectedShipmentByCustomer[customerCode].denno_shipments.push(row.denno_shipment);
      return selectedShipmentByCustomer;
    }, {});

    return selectedShipmentByCustomer;
  }

  isDisplayReOrder(item) {
    return (![this.postAgeItemCode, this.pipPostAgeItemCode].includes(item.item_code)) && item.item_status
  }

  async reOrder(cart, itemId, productImage) {
    if (cart.item.set_item_code) {
      this.addCart([
        {
          set_item_code: cart.item.set_item_code,
          item_code: cart.item.item_code,
          cart_quanlity: cart.item.set_quantity ?? 0,
        },
      ]);
    } else {
      this.addCart([
        {
          set_item_code: null,
          item_code: cart.item.item_code,
          cart_quanlity: cart.item.orre_quantity ?? 0,
        },
      ]);
    }

    if (this.cartItems.length > 0) {
      this.addCartAnimation(itemId, productImage)
      return;
    } else {
      qNotify.error({
        text: this.$t("cart_page.messsage.empty_cart"),
      });
    }
  }

  public async addCartAnimation(itemId, productImage)
  {
    const cartIcon = document.querySelector("#Cart");
    const { x, y } = cartIcon.getBoundingClientRect();
    const nodeId = "#" + itemId
    const node = document.querySelector(nodeId);
    const productImageCloneClass = productImage + "-clone"
    const nodeProduct = document.querySelector("." + productImage);
    const clone: any = nodeProduct.cloneNode(true);
    clone.setAttribute('class', "mb__image-fit-contain " + productImageCloneClass)
    const styles = [
      "position:absolute",
      "opacity: 0.8",
      `left:${nodeProduct.getBoundingClientRect().x}px`,
      `top:${window.pageYOffset + node.getBoundingClientRect().y}px`,
      `width: ${nodeProduct.clientWidth}px`,
      `border: 5px solid #ccc`,
    ];

    clone.style = styles.join(";");
    document.querySelector("body").append(clone);

    anime({
      targets: "." + productImageCloneClass,
      easing: "easeInOutSine",
      top: [
        { value: window.pageYOffset + y + 50, duration: 800, delay: 300 },
        { value: window.pageYOffset + y - 200, duration: 1000, delay: 200 },
      ],
      left: [
        { value: x - nodeProduct.clientWidth / 4, duration: 800, delay: 300 },
      ],
      scale: {
        value: 0,
        duration: 1000,
        delay: 1100,
        easing: "easeInOutQuart",
      },
      delay: 200,

      complete: () => {
        setTimeout(() => {
          anime({
            targets: "#Cart",
            translateX: [
              { value: 10, duration: 50 },
              { value: -10, duration: 50 },
              { value: 10, duration: 50 },
              { value: -10, duration: 50 },
              { value: 10, duration: 50 },
              { value: -10, duration: 50 },
              { value: 0, duration: 50 },
            ],
          });
        });

        clone.remove();
      },
    });
  }

  public isReplayFee(value) {
    return value === this.isRelayFee;
  }

  get countShipment() {
    return _filter(this.orderHistories, (item) => item.status == "出荷済")
      .length;
  }

  @Watch("orderSelected")
  public async changeStatusOfSelectAllCheckbox() {
    if (this.orderSelected.length > 0) {
      this.isStatusAll = this.orderSelected.length == this.countShipment;
    }
  }

  public formatDesireDlvrDay(desireDlvrDay) {
    return moment(desireDlvrDay).format(DATE_TIME_TEXT_FORMAT);
  }

  public showDetail(cart) {
    (this.$refs.productPopup as QProductPopup).show({
      item_code: cart.item.item_code
    });
  }
}
